@if (!hasPermission) {
  <div class="flex items-center justify-center gap-2 rounded-lg border border-red-200 bg-red-50 p-6 text-sm font-semibold text-red-700">
    <mat-icon class="!text-base text-red-400">lock</mat-icon>
    Permissions Restricted
  </div>
} @else {
  <div>
    <h3 class="text-secondary mb-3 text-sm font-semibold uppercase tracking-wide">{{ title }}</h3>

    @if (loading) {
      <div class="flex justify-center py-4"><mat-spinner diameter="28" color="primary" /></div>
    }

    @if (error && !loading) {
      <div class="text-secondary flex items-center gap-2 py-3 text-sm">
        <mat-icon class="text-base text-gray-400">error_outline</mat-icon>
        {{ error }}
      </div>
    }

    @if (!loading && !error) {
      <div class="divide-y divide-gray-50">
        @for (item of items; track item.label) {
          @let cfg = getStatusClasses(item.status);
          <div class="flex items-center gap-2.5 py-2.5 transition-colors hover:bg-gray-50">
            <!-- Icon badge -->
            <div
              class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg"
              [class.bg-green-50]="item.status === 'ok'"
              [class.bg-orange-50]="item.status === 'warning'"
              [class.bg-red-50]="item.status === 'critical'"
            >
              <mat-icon class="!text-sm" [class.text-green-500]="item.status === 'ok'" [class.text-orange-500]="item.status === 'warning'" [class.text-red-500]="item.status === 'critical'">{{
                cfg.icon
              }}</mat-icon>
            </div>
            <!-- Label -->
            <span class="min-w-0 flex-1 truncate text-xs font-medium text-gray-700">{{ item.label }}</span>
            <!-- Count badge or checkmark -->
            @if (item.value > 0) {
              <span
                class="shrink-0 rounded-full px-2 py-0.5 text-[10px] font-bold leading-none"
                [class.bg-red-100]="item.status === 'critical'"
                [class.text-red-700]="item.status === 'critical'"
                [class.bg-orange-100]="item.status === 'warning'"
                [class.text-orange-700]="item.status === 'warning'"
                [class.bg-green-100]="item.status === 'ok'"
                [class.text-green-700]="item.status === 'ok'"
              >
                {{ item.value }}
              </span>
            } @else {
              <div class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-50">
                <mat-icon class="!text-xs text-green-500">check</mat-icon>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
